import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "../components/ui/accordion";
import { fadeUp, viewportOnce } from "../lib/motion";
import { FAQS, REFUND_POLICY_URL } from "../lib/plans";

const PricingFaq = () => (
    <section
        data-testid="pricing-faq-section"
        className="relative bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    QUESTIONS
                </p>
                <span className="h-px flex-1 bg-white/10" />
            </motion.div>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-12 max-w-3xl"
            >
                <Accordion
                    type="single"
                    collapsible
                    data-testid="pricing-faq-accordion"
                >
                    {FAQS.map((item, i) => (
                        <AccordionItem
                            key={item.q}
                            value={`faq-${i}`}
                            className="border-white/10"
                        >
                            <AccordionTrigger
                                data-testid={`pricing-faq-trigger-${i + 1}`}
                                className="py-5 text-left text-[16px] font-medium text-white hover:no-underline hover:text-accent"
                            >
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="border-l border-accent/40 pl-4 text-[15px] leading-relaxed text-mist">
                                {item.refund ? (
                                    <a
                                        href={REFUND_POLICY_URL}
                                        data-testid="pricing-refund-policy-link"
                                        className="inline-flex items-center text-accent transition-colors duration-300 hover:text-[#ff7026]"
                                    >
                                        Cooling-off and refund policy
                                    </a>
                                ) : (
                                    item.a
                                )}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </motion.div>
        </div>
    </section>
);

export default PricingFaq;
